// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__23gUF","main":"Button_main__bsEeq","secondary":"Button_secondary__V9qgi"};